import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRightArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 14,
	viewBox: "0 0 8 14",
	fill: "#929292",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M0 12L5 7L0 2L1 0L8 7L1 14L0 12Z" })]
});
const ForwardRef = forwardRef(SvgRightArrow);
export { ForwardRef as ReactComponent };
